import React from 'react';
import '../../styles/OrganSystemInfoModal.css';
import BottomSheet from '../BottomSheet/BottomSheet';

function OrganSystemInfoModal({ systemId, systemInfo, markers, onClose }) {
    if (!systemInfo || !markers) return null;

    const sortedMarkers = Object.entries(markers)
        .sort(([, a], [, b]) => b.confidence_weight - a.confidence_weight);

    const totalWeight = Object.values(markers).reduce((sum, m) => sum + m.confidence_weight, 0);

    const majorContributors = sortedMarkers.filter(([, data]) =>
        (data.confidence_weight / totalWeight) >= 0.15
    );
    const minorContributors = sortedMarkers.filter(([, data]) =>
        (data.confidence_weight / totalWeight) < 0.15
    );

    return (
        <BottomSheet onClose={onClose} className="system-modal" zIndex={10000}>
            {({ onClose: handleClose }) => (
                <>
                    <div className="modal-header">
                        <h2>{systemInfo.displayName}</h2>
                        <button className="close-btn" onClick={handleClose} aria-label="Close modal">×</button>
                    </div>
                    <div className="modal-body">
                        <section>
                            <h3>Overview</h3>
                            <p>{systemInfo.description}</p>
                        </section>

                        <section>
                            <h3>Contributing tests</h3>
                            <p>{systemInfo.testsExplanation}</p>

                            {majorContributors.length > 0 && (
                                <div className="test-group">
                                    <h4>Major Contributors</h4>
                                    <ul className="test-list">
                                        {majorContributors.map(([name]) => (
                                            <li key={name}>{name}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            {minorContributors.length > 0 && (
                                <div className="test-group">
                                    <h4>Minor Contributors</h4>
                                    <ul className="test-list">
                                        {minorContributors.map(([name]) => (
                                            <li key={name}>{name}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </section>

                        <section>
                            <h3>How scoring works</h3>
                            <p>{systemInfo.scoringExplanation}</p>
                        </section>

                        {systemInfo.sources && (
                            <section className="sources-section">
                                <h3>More Reading</h3>
                                <ul className="sources-list">
                                    {systemInfo.sources.map((source, idx) => (
                                        <li key={idx}>
                                            <a href={source.url} target="_blank" rel="noopener noreferrer">
                                                {source.name}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </section>
                        )}
                    </div>
                </>
            )}
        </BottomSheet>
    );
}

export default OrganSystemInfoModal;
